define.alias("shared/components/shared/profile-timezone-select", "settings/components/shared/profile-timezone-select");